import styled from 'styled-components'

const StyledWrapper = styled.div`
  label {
    border: 0;
    font: inherit;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  input {
    letter-spacing: -0.8px;
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
`

export const DivWrapper = styled.div``

export default StyledWrapper
